export default "__VITE_ASSET__771e51cf__"